export const LOADER_STORE_NAME = "gloalLoader";
